/**
 * demo.ts — Client for the demo-tenant walkthrough endpoints.
 *
 * Only callable when the active session belongs to the
 * `imtithal-demo` tenant. The backend rejects every call from any
 * other tenant with 403, so the client should ALWAYS gate the
 * surfacing of these calls on `user.tenantSubdomain === 'imtithal-demo'`.
 */

import { apiClient } from '@/lib/api-client';
import type { LoginResponse } from '@/types/auth';

export interface DemoAccountSummary {
  emailLocal: string;
  email: string;
  firstName: string;
  lastName: string;
  roleKey: string;
  roleNameAr: string;
  roleNameEn: string;
  departments: string[];
}

export const demoApi = {
  async listAccounts(): Promise<DemoAccountSummary[]> {
    const { data } = await apiClient.get<DemoAccountSummary[]>('/demo/accounts');
    return data;
  },

  async switchAccount(emailLocal: string): Promise<LoginResponse> {
    const { data } = await apiClient.post<LoginResponse>('/demo/switch-account', {
      emailLocal,
    });
    return data;
  },
};
